export type MarketerProductsCellItem = {
    id: string;
    productName: string;
    access: MarketerAccess;
    isEdited: boolean;
    isRemoving: boolean;
    selectedAccess: MarketerAccess;
};

export const MARKETERS_PREFIX = 'marketers';

export interface Marketer {
    id: string;
    login: string;
    fullName: string;
    ownProducts: MarketerProduct[];
}

export interface Marketers {
    marketers: Marketer[];
    pageStatus: MarketersPageStates;
    allMarketers: Marketer[];
    filter: FilterParams;
}

export interface MarketerCardData {
    marketer: {
        id: string;
        login: string;
        fullName: string;
        ownProducts: MarketerProductsCellItem[];
    };
    pageStatus: MarketersPageStates;
    productForm: MarketerAddProductForm;
    gridOffset?: number;
}

export interface MarketerAddProductForm {
    access: MarketerAccess;
    product: {
        productId: string;
        productName: string;
    };
    isEnabled?: boolean;
}

export interface MarketerProduct {
    productName: string;
    id: string;
    access: MarketerAccess;
}

export enum MarketerAccess {
    canRead = 'Read',
    canWrite = 'Write'
}

export const ACCESS_SELECTORS = [
    { text: MarketerAccess.canRead, val: MarketerAccess.canRead },
    { text: MarketerAccess.canWrite, val: MarketerAccess.canWrite }
];

export interface FilterParams {
    product: string;
    access?: MarketerAccess[];
}

export enum MarketersPageStates {
    PENDING = 'PENDING',
    LOADING = 'LOADING',
    FETCH_FORM = 'FETCH_FORM',
    ACTION = 'ACTION',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
    NOT_FOUND = 'NOT_FOUND'
}

export interface ServerMarketer {
    clientId: number;
    productLogin: string;
    username: string;
    availableProducts: ServerMarketerProduct[];
}

export interface ServerMarketerProduct {
    productId: number;
    productName: string;
    placeIds: number[];
    accessType: ServerMarketerAccess;
}

export enum ServerMarketerAccess {
    canWrite = 'FULL',
    canRead = 'READONLY'
}
